import * as React from 'react';
var PaymentConfigContext = React.createContext(null);
var PaymentConfigProvider = function (props) { return (React.createElement(PaymentConfigContext.Provider, { value: props.value }, props.children)); };
var usePaymentConfigContext = function () {
    var context = React.useContext(PaymentConfigContext);
    return context;
};
export { PaymentConfigProvider, usePaymentConfigContext };
